module.exports = __webpack_public_path__ + "static/media/who.f365bd46.png";